import React from 'react';

export const formatMessageContent = ( text ) => {
	if ( !text ) return '';
	
	const parts = text.split( /(\*[^*]+\*)/ );
	return parts.map( ( part, index ) => {
		if ( part.startsWith( '*' ) && part.endsWith( '*' ) ) {
			return <strong key={index}>{part.slice( 1, -1 )}</strong>;
		}
		return part;
	} );
}; 